import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

// Material modules
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomTranslatePipe } from '../utils/pipes-utils/CustomTranslatePipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatSnackBarModule,
  ],
  declarations: [
    CustomTranslatePipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatSnackBarModule,
    CustomTranslatePipe
  ]
})
export class SharedModule { }